'use strict';

$(function () {
  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/

  Shopify.moveAlong = function () {
    // If we still have requests in the queue, let's process the next one.
    if (Shopify.queue.length) {
      var request = Shopify.queue.shift();
      Shopify.addItem(request.variantId, request.quantity, Shopify.moveAlong);
    }
    // If the queue is empty, we will redirect to the cart page.
    else {
      Suit.minicart.refreshMinicart(Suit.minicart.openMinicart);
    }
  };

  Shopify.addItem = function (variant_id, quantity, callback) {
    var quantity = quantity || 1;
    $.ajax({
      type: 'POST',
      url: window.Shopify.routes.root + 'cart/add.js',
      data: 'quantity=' + quantity + '&id=' + variant_id,
      dataType: 'json',
      success: function success(line_item) {
        if (typeof callback === 'function') {
          callback(line_item);
        } else {
          Suit.minicart.refreshMinicart(Suit.minicart.openMinicart);
        }
      },
      error: function error(XMLHttpRequest, textStatus) {
        //Shopify.onError({ message: Shopify.trans.productsProductWarning, description: Shopify.trans.productsProductAdd_to_cart_error });

        console.log(XMLHttpRequest);
        var message = XMLHttpRequest.responseJSON.message;
        Shopify.onError({ message: Shopify.trans.productsProductWarning, description: message });
        Suit.minicart.refreshMinicart();
      }
    });
  };

  Shopify.onError = function (_ref, textStatus) {
    var message = _ref.message,
        description = _ref.description;

    // todo: we don't have a graphic for error message, in case use this to customize the error class name and add it where needed
    var errorClass = textStatus === 'error' ? ' error' : '';

    if (window.Suit) {
      var modal = '\n      <div class="modal modal--messages" data-modal-overlay="true">\n        <div class="modal__wrapper">\n          <button class="modal__close">\n            <svg xmlns="http://www.w3.org/2000/svg" class="{{ icon }}-svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="8.485" height="8.485" viewBox="0 0 8.485 8.485" fill="#707070">\n              <defs>\n                <clipPath id="a">\n                  <rect class="a" width="8.485" height="8.485"/>\n                </clipPath>\n              </defs>\n              <g class="b">\n                <rect width="11" height="1" transform="translate(7.778 8.485) rotate(-135)"/>\n                <rect width="11" height="1" transform="translate(0 7.778) rotate(-45)"/>\n              </g>\n            </svg>\n          </button>\n          <div class="modal__title">\n            <h4>' + message + '</h4>\n          </div>\n          <div class="modal__content">\n            ' + description + '\n          </div>\n        </div>\n      </div>\n      ';
      $("body").append(modal);

      Suit.modal.open('.modal--messages');

      // when closing the modal, remove it from dom
      $('.modal--messages').on('modal-close', function () {
        $(this).remove();
      });
    } else {
      alert(description);
    }
  };

  Shopify.changeItem = function (line, quantity, callback) {
    var params = {
      type: 'POST',
      url: window.Shopify.routes.root + 'cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      success: function success(cart) {
        if (typeof callback === 'function') {
          callback();
        } else {
          //Shopify.onCartUpdate(cart);
        }
      },
      error: function error(XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest);
        var message = XMLHttpRequest.responseJSON.message;
        Shopify.onError({ message: Shopify.trans.productsProductWarning, description: message });
        Suit.minicart.refreshMinicart();
      }
    };
    jQuery.ajax(params);
  };

  Shopify.ajaxSubmitCart = function (cart) {
    $cart = cart;
    $.ajax({
      url: window.Shopify.routes.root + 'cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success: function success(data) {
        Shopify.refreshCart(data);
      }
    });
  };

  Shopify.ajaxUpdateCart = function (lineID, quantity, parent, div) {
    $.ajax({
      url: window.Shopify.routes.root + 'cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: { quantity: quantity, line: lineID },
      success: function success(data) {
        Shopify.refreshCart(data);
        Suit.minicart.refreshMinicart();
        var lineIDIndex = lineID - 1;

        if (quantity == 0) {
          location.reload();
        }

        //check to see if there are correct amount of products in array
        if (typeof data.items[lineIDIndex] === "undefined") {
          var updated_quantity = 0;
        } else {
          var updated_quantity = data.items[lineIDIndex].quantity;
        }

        if (quantity > 0 && quantity != updated_quantity) {
          console.log('error');
          Shopify.onError({ message: Shopify.trans.productsProductWarning, description: Shopify.trans.productsProductCart_quantity_message });
          parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);
        } else if (parent.is('#cart_form')) {
          //$("#cart_form").submit();
        }
      },
      error: function error(XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest);
        var message = XMLHttpRequest.responseJSON.message;
        Shopify.onError({ message: Shopify.trans.productsProductWarning, description: message });
        parent.find("input[data-line-id='" + lineID + "']").val(parseInt(quantity - 1));
      }
    });
  };

  Shopify.refreshCart = function (cart) {
    $(".cart_count").empty();
    var $cartBtn = $(".cart_count");
    var value = $cartBtn.text() || '0';
    var cart_action_html = "";
    var $cart = $(".cart_content form");
    var discounted_price_total = 0;

    var htmlEncode = function htmlEncode(value) {
      if (value) {
        return $('<div/>').text(value).html();
      } else {
        return '';
      }
    };

    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));
    Suit.minicart.refreshMinicart();

    if (cart.item_count == 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $('.js-cart_content__form').addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $('.js-cart_content__form').removeClass('hidden');

      $.each(cart.items, function (index, item) {
        $('.cart-item[data-item-id = "' + item.id + '"] .js-cart-item__price .money').text(Shopify.formatMoney(item.price * item.quantity, $('body').data('money-format')));
      });

      cart_action_html += '<span>' + Shopify.trans.layoutGeneralSubtotal + '</span>' + '<span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span>';
    }

    $('.js-cart_subtotal').html(cart_action_html);
  };

  Shopify.updateVariantSubtotal = function (el) {
    var moneyFormat = $('body').data('money-format');
    var line = $(el).parents('tr');
    var qty = line.find('.select-variant__qty').val();
    var price = line.find('.js-price').data('price');
    var subtotal = line.find('.js-subtotal');
    var newTotal = price * qty;
    $(subtotal).data('price', newTotal).text(Shopify.formatMoney(newTotal, moneyFormat));
    Shopify.sumVariantSubtotal();
  };

  Shopify.sumVariantSubtotal = function () {
    var moneyFormat = $('body').data('money-format');
    if ($('.js-linesubtotal').length > 0) {
      $('.js-linesubtotal').each(function (i, el) {
        var total = 0;
        var subtotals = $(el).parents('table').find('.js-subtotal');
        if (subtotals.length > 0) {
          subtotals.each(function (i, el) {
            var sub = parseInt($(this).data('price'));
            total = parseInt(total) + sub;
          });
          $(el).text(Shopify.formatMoney(total, moneyFormat));
        }
      });
    }
  };

  Shopify.sumVariantSubtotal();

  // events attachment
  $('body').on("change", "#cart_form input.quantity", function () {
    Shopify.ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart_form'));
  });

  $(document).on('click', "#cart_form .js-update-qty", function (e) {
    var input = $(this).parents('tr').find('.select-variant__qty');
    Shopify.ajaxUpdateCart(input.data('line-id'), input.val(), $(this).parents('#cart_form'));
    Shopify.updateVariantSubtotal(e.target);
  });

  $('.select-variant__qty').focus(function () {
    if (parseInt(this.value) === 0) this.value = '';
  }).keypress(function (evt) {
    // prevent typing 'e', '-', '+'
    if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57) evt.preventDefault();
  }).keyup(function () {
    // do not allow letters
    if (this.value > parseInt($(this).attr('max'))) {
      this.value = parseInt($(this).attr('max'));
    }
  }).blur(function () {
    if (this.value === '') this.value = 0;
  });

  $('body').on('submit', ".product_form form, .shopify-product-form", function (e) {
    e.preventDefault();
    var form = this;
    var $addToCartForm = $(form);
    var isB2b = $addToCartForm.find('.select-variant__table').length > 0;
    var isGiftCard = $addToCartForm.find('.select-variant__giftquantity').length > 0;

    if (isB2b) {
      Shopify.queue = [];

      $('.select-variant__qty').each(function () {
        if (this.value > 0) {
          Shopify.queue.push({
            variantId: $(this).data('id'),
            quantity: parseInt(this.value, 10) || 0
          });
        }
      });

      // process all products in queue with quantity
      Shopify.moveAlong();
    } else {
      if (isGiftCard) {
        var quantity = parseInt($addToCartForm.find('.select-variant__giftquantity')[0].value);
        Shopify.addItem(form.id.value, quantity);
      } else {
        Shopify.addItem(form.id.value);
      }
    }
  });
});
